export default __webpack_public_path__ + "static/media/cif-sl.fee66dd5.svg";